import { render, staticRenderFns } from "./TsWaiting.vue?vue&type=template&id=7acb2958&functional=true"
import script from "./TsWaiting.vue?vue&type=script&lang=js"
export * from "./TsWaiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports